import _isString from 'lodash/isString';

import { DAILY_BANNER_KEYS, getDowntimeDateVal } from 'constants/banner-types';

import { CLOSE_ERROR_BAR, SHOW_ERROR_BAR } from '../constants/actions';

let localStorage;

// block third party cookies check
// https://useloom.atlassian.net/browse/LOOM-1639
try {
  localStorage = window && window.localStorage;
} catch (err) {
  // do nothing
}

export const closeErrorBar = () => {
  return (dispatch, getState) => {
    const { error_bar } = getState();
    const { bannerId = '' } = error_bar;

    dispatch({ type: CLOSE_ERROR_BAR });

    if (DAILY_BANNER_KEYS.includes(bannerId)) {
      localStorage?.setItem(bannerId, getDowntimeDateVal());
    }
  };
};

export const showErrorBar = (
  severity,
  message,
  bannerId,
  primaryButtonLabel,
  actionHref
) => {
  const messageString = _isString(message)
    ? message
    : (message.toString && message.toString()) || 'Oops! Something went wrong';

  return {
    type: SHOW_ERROR_BAR,
    severity,
    message: messageString,
    bannerId,
    primaryButtonLabel,
    actionHref,
  };
};
